import { Component, Input } from '@angular/core';
import { BaseApiService } from '@shared/base';
import { Account } from '@shared/models';

type UserAvaSize = 'xs' | 'sm' | 'md' | 'lg';

@Component({
  selector: 'gcc-user-ava',
  templateUrl: './user-ava.component.html',
  styleUrls: ['./user-ava.component.scss']
})
export class UserAvaComponent extends BaseApiService {
  @Input() public user: Account;
  @Input() public size: UserAvaSize;
}
